import * as Analytics from './Analytics';
import firebase from "firebase/app";
import 'firebase/firestore';
require('firebase/database');
require('firebase/storage');
require('firebase/auth');

let config = {
  apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY,
  authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.REACT_APP_FIREBASE_RTDB_ID}.firebaseio.com`,
  storageBucket: `gs://${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID
};
var firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp(config);
} else {
  firebaseApp = firebase.apps[0];
}
const database = firebaseApp.database();
const firestore = firebaseApp.firestore();
const storage = firebaseApp.storage();
export const storageRef = storage.ref();
let _ = require('lodash');

// NOTE: Make sure these  match the similarly-named values in the vivabot project
// FUTURE: Move to a shared lib
export const SUBSCRIPTION_STATUS = {
  'Active': 'Active',
  'Sporadic': 'Sporadic',
  'Paused': 'Paused',
  'NagLover': 'NagLover'
};
export const SUBSCRIPTION_STAGE = {
  Assessment: 'Assessment',
  FreeTrial: 'FreeTrial',
  Onboarding: 'Onboarding',
  Waitlist: 'Waitlist',
  Missing: 'Missing',
  WaitingForSubscriptionDecision: 'WaitingForSubscriptionDecision',
  Paid: 'Paid',
  PaymentError: 'PaymentError',
  Canceled: 'Canceled'
};

export const TODO_SHORTHAND = {
  QYesterdayLog: "Seems didn't log all foods yesterday",
  OverTarget: "Will be over 1.05 x week goal",
  progressCheckTime: "Confirm progress check day & time",
  tipSaveRecipe: "Pro-tip: save recipe",
  tipRecipeLink: "Pro-tip: extract nutrition info from recipe link",
  tipSameAs: "Pro-tip: same as...",
  tipOutExercise: "Pro-tip: can't out-exercise diet",
  tipTrackingAccuracy: "Pro-tip: food tracking accuracy",
  setShortTermGoal: "Set a short-term (3 mo away) goal",
  ateLessThan66Percent: "Ate <66% of",
  ateMoreThan66Percent: "Ate >66% of"
};

export const GOAL = {
  UNDEFINED: 'UNDEFINED',
  LoseFat: 'LOSEFAT',
  BuildMuscle: 'BUILDMUSCLE',
  Maintain: 'MAINTAIN'
};

export const NUTRITION_DATA_UNIT_MAP = {
  'calories': 'kcal',
  'protein': 'g',
  'carbs': 'g',
  'fat': 'g',
  'fiber': 'g',
  'netCarbs': 'g',
  'sugar': 'g'
};

export const NUTRITION_DATA_UNIT_REPORT_MAP = {
  'calories': 'kcal',
  'protein': 'g Protein',
  'carbs': 'g Carbs',
  'fat': 'g Fat',
  'fiber': 'g Fiber',
  'netCarbs': 'g Net Carbs',
  'sugar': 'g Sugar'
};

export const FOOD_GROUP_HABITS_UNIT_MAP = {
  'water': 'cups'
};

export const SUBMIT_FOOD_INTENTION = {
  AddOrCorrect: 'AddOrCorrect',
  Correct: 'Correct',
  Move: 'Move',
  Copy: 'Copy',
};

export function getUnitForFoodTargetName(name) {
  return NUTRITION_DATA_UNIT_MAP[name] ?
    NUTRITION_DATA_UNIT_MAP[name] :
    (FOOD_GROUP_HABITS_UNIT_MAP[name] ? FOOD_GROUP_HABITS_UNIT_MAP[name] : '');
}

let UserSubscriptionsCache = [];

export function isUserWaitlisted(userId) {
  let sub = getUserSubscriptionById(userId);
  return (sub && sub.stage === SUBSCRIPTION_STAGE.Waitlist);
}

function getUserSubscriptionById(userId) {
  return UserSubscriptionsCache[userId];
}

export function getUserSubscriptions(callback) {
  if (!_.isEmpty(UserSubscriptionsCache)) {
    if (callback) {
      callback(UserSubscriptionsCache);
    }
    return;
  }

  database.ref('userSubscriptions').once("value").then((snapshot) => {
    if (snapshot.exists()) {
      let itemsProcessed = 0;
      let userSubscriptions = [];
      UserSubscriptionsCache = snapshot.val();
      let uids = Object.keys(UserSubscriptionsCache);

      uids.forEach(uid => {
        let user = UserSubscriptionsCache[uid];
        userSubscriptions.push({
          id: uid,
          name: user.name,
          status: user.status,
          stage: user.stage,
          stageStart: user.stageStart
        });

        itemsProcessed++;
        if (itemsProcessed >= uids.length - 1) {
          if (callback) {
            callback(userSubscriptions);
          }
        }
      });
    }
  }, function (error) {
    console.error("The read from firebase at userSubscriptions failed: " + error);
  });
}

export const DEFAULT_BUFFER_VAL = 10;

export function doOnGetBufferObj(userId, type, callback) {
  doOnReadingFirebaseEntry(getBufferPath(userId, type), (snapshot) => {
    if (snapshot.exists()) {
      callback(snapshot.val());
    } else {
      callback({ enabled: false, value: DEFAULT_BUFFER_VAL });
    }
  });
}

export function enableBuffer(userId, type, isEnabled) {
  setFirebaseEntry(`${getBufferPath(userId, type)}/enabled`, isEnabled);
}

export function updateBufferValue(userId, type, value) {
  setFirebaseEntry(`${getBufferPath(userId, type)}/value`, value);
}

function getBufferPath(userId, type) {
  return `users/${userId}/buffers/${type}`;
}

export function doOnSmallBitesValChange(userId, type, callback) {
  doOnValueChange(getSmallBitesBufferPath(userId, type), (key, val) => {
    callback(val);
  });
}

export function clearAllSmallBitesCallbacks(userId, type) {
  clearAllCallbacks(getSmallBitesBufferPath(userId, type));
}

export function updateSmallBitesBuffer(userId, type, value) {
  setFirebaseEntry(`${getSmallBitesBufferPath(userId, type)}`, value);
}

function getSmallBitesBufferPath(userId, type) {
  return `users/${userId}/smallBitesBuffer/${type}`;
}

// IMPORTANT: Many of these below are equivalent to the functions for database.js in the vivabot project.
// If you change these, check whether or not you need to change for database.js in vivabot too.
// FUTURE: Move these to a shared lib.
export function updateUserSubscriptionStage(userId, stage) {
  if (stage === SUBSCRIPTION_STAGE.Canceled) {
    createTODOAsync(userId, `UNMARK this user as Viva Client in Mailchimp`, 'high', null, 'manual', null);
  }

  if (stage === SUBSCRIPTION_STAGE.Paid) {
    createTODOAsync(userId, `Ask Lucy to send this user the Gift Card notification`, 'high', null, 'manual', null);
    createTODOAsync(userId, `Mark this user as Viva Client in Mailchimp`, 'high', null, 'manual', null);
    createTODOAsync(userId, `Add this user's stripe id to userSubscriptions/<user id>/stripeId`, 'high', null, 'manual', null);
  }

  setFirebaseEntry(`${getUserSubscriptionPath(userId)}/stage`, stage);
  let now = Date.now();
  setFirebaseEntry(`${getUserSubscriptionPath(userId)}/stageStart`, Date.now());
  if (stage === SUBSCRIPTION_STAGE.FreeTrial) {
    doOnReadingFirebaseEntry(`${getUserSubscriptionPath(userId)}/freeTrialStart`, (snapshot) => {
      if (!snapshot.exists()) { // Set this once and only once.
        setFirebaseEntry(`${getUserSubscriptionPath(userId)}/freeTrialStart`, now);
      }
    });
  }
}

export function updateUserSubscriptionStatus(userId, status) {
  setFirebaseEntry(`${getUserSubscriptionPath(userId)}/status`, status);
  setFirebaseEntry(`${getUserSubscriptionPath(userId)}/statusStart`, Date.now());
}

export async function doOnReadingFirebaseEntry(path, callback, callbackIfError /*optional*/) {
  var pathRef = database.ref(path);
  pathRef.once("value").then(function (snapshot) {
    callback(snapshot);
  }, function (error) {
    console.error("doOnReadingFirebaseEntry: The read from firebase at " + path + "failed: " + error);
    if (callbackIfError) {
      callbackIfError(error);
    }
  });
}

export async function doOnReadingFirebaseRangedEntriesAsync(path, beginKey, endKey, callback, callbackIfError /* optional */) {
  var pathRef = database.ref(path);
  pathRef.orderByKey().startAt(beginKey).endAt(endKey).once("value").then(function (snapshot) {
    callback(snapshot);
  }, function (error) {
    console.error("doOnReadingFirebaseRangedEntriesAsync: The read from firebase at " + path + "failed: " + error);
    if (callbackIfError) {
      callbackIfError(error);
    }
  });
}

export async function getFirebaseEntryAsync(path) {
  let snapshot = await database.ref(path).once("value");
  if (snapshot.exists()) {
    return snapshot.val();
  }
  return null;
}

export async function getFirebaseRangedEntriesAsync(path, beginKey, endKey) {
  let snapshot = await database.ref(path).orderByKey().startAt(beginKey).endAt(endKey).once("value");
  if (snapshot.exists()) {
    return snapshot.val();
  }
  return null;
}

export async function getFirebaseEntryAsyncWithKey(path) {
  let snapshot = await database.ref(path).once("value");
  if (snapshot.exists()) {
    return { key: snapshot.key, val: snapshot.val() };
  }
  return null;
}

export function setFirebaseEntry(path, value) {
  if (!path) {
    console.error('setFirebaseEntry: no path provided!');
    return;
  }

  var pathRef = database.ref(path);
  pathRef.set(value, function (error) {
    if (error) {
      console.error(error);
    }
  });
}

export async function setFirebaseEntryAsync(path, value) {
  if (!path) {
    console.error('setFirebaseEntryAsync: no path provided!');
    return;
  }

  var pathRef = database.ref(path);
  await pathRef.set(value);
}

export function pushFirebaseEntry(path, value) {
  var pathRef = database.ref(path);
  var newKey = pathRef.push().key;
  var newRef = database.ref(path + '/' + newKey)
  newRef.set(value);
  return newKey;
}

export function doOnChildAdded(path, callback) {
  database.ref(path).on('child_added', (snapshot) => {
    callback(snapshot.key, snapshot.val());
  });
}

export function doOnChildChanged(path, callback) {
  database.ref(path).on('child_changed', (snapshot) => {
    callback(snapshot.key, snapshot.val());
  });
}

export function doOnChildRemoved(path, callback) {
  database.ref(path).on('child_removed', (snapshot) => {
    callback(snapshot.key, snapshot.val());
  });
}

export function doOnValueChange(path, callback) {
  database.ref(path).on('value', (snapshot) => {
    callback(snapshot.key, snapshot.val());
  });
}

export function clearChildAddedCallback(path) {
  database.ref(path).off('child_added');
}

export function clearChildChangedCallback(path) {
  database.ref(path).off('child_changed');
}

export function clearChildRemovedCallback(path) {
  database.ref(path).off('child_removed');
}

export function clearValueChangeCallback(path) {
  database.ref(path).off('value');
}

export function clearAllCallbacks(path) {
  database.ref(path).off();
}

// For arrays
export function appendFirebaseEntry(path, value) {
  var pathRef = database.ref(path);
  pathRef.once("value").then(function (snapshot) {
    if (snapshot.exists()) {
      var nextIndex = snapshot.val().length;
      pathRef.child(nextIndex).set(value)
    } else {
      pathRef.child("0").set(value);
    }
  }, function (error) {
    console.error("The read from firebase at " + path + "failed: " + error);
    //callbackIfError(error);
  });
}

export async function appendFirebaseEntryAsync(path, value) {
  var pathRef = database.ref(path);
  let snapshot = await pathRef.once("value");
  if (snapshot.exists()) {
    var nextIndex = snapshot.val().length;
    pathRef.child(nextIndex).set(value)
  } else {
    pathRef.child("0").set(value);
  }
}

function getUserSubscriptionPath(userId) {
  return `userSubscriptions/${userId}`;
}

export async function getUserGoalsSnapshotAsync(userId) { // Call this sparingly. Should only be called by UserPanel
  let snapshot = await database.ref(`users/${userId}/goals`).once("value");
  return snapshot;
}

export function setUserGoalsObj(userId, keyPath, value) {
  setFirebaseEntry(`users/${userId}/goals/${keyPath}`, value);
}

export async function setUserGoalsObjAsync(userId, keyPath, value) {
  await setFirebaseEntryAsync(`users/${userId}/goals/${keyPath}`, value);
}

export function setDashboardSettings(userId, keyPath, value) {
  setFirebaseEntry(`users/${userId}/dashboardSettings/${keyPath}`, value);
}

export async function setDashboardSettingsAsync(userId, keyPath, value) {
  await setFirebaseEntryAsync(`users/${userId}/dashboardSettings/${keyPath}`, value);
}

export async function claimUserInteractionAsync(adminId, userId, interactionType) {
  setFirebaseEntry(`adminTool/interactions/admins/${adminId}/${interactionType}`, userId);

  let activeAdminsString = await getFirebaseEntryAsync(`adminTool/interactions/users/${userId}/${interactionType}`);
  if (activeAdminsString) {
    if (activeAdminsString === adminId) {
      return { claimed: true, activeAdmins: activeAdminsString };
    } else {
      let activeAdmins = activeAdminsString.split(',');
      if (!_.includes(activeAdmins, adminId)) {
        activeAdminsString = `${activeAdminsString},${adminId}`;
      }
      setFirebaseEntry(`adminTool/interactions/users/${userId}/${interactionType}/`, activeAdminsString);
      return { claimed: false, activeAdmins: activeAdminsString };
    }
  } else {
    setFirebaseEntry(`adminTool/interactions/users/${userId}/${interactionType}/`, adminId);
    return { claimed: true, activeAdmins: [adminId] };
  }
}

export function waitOnUserInteractionChange(adminId, userId, interactionType, callback) {
  doOnValueChange(`adminTool/interactions/users/${userId}/${interactionType}`, (key, val) => {
    if (val && val === adminId) {
      callback({ claimed: true, activeAdmins: [adminId] });
    }
  });
}

export async function releaseUserInteractionAsync(adminId, interactionType) {
  let userId = await getFirebaseEntryAsync(`adminTool/interactions/admins/${adminId}/${interactionType}`);
  let activeAdminsString = await getFirebaseEntryAsync(`adminTool/interactions/users/${userId}/${interactionType}`);
  if (activeAdminsString) {
    let activeAdmins = activeAdminsString.split(',');
    _.pull(activeAdmins, adminId);
    setFirebaseEntry(`adminTool/interactions/users/${userId}/${interactionType}`, activeAdmins.length ? activeAdmins.join(',') : null);
    clearValueChangeCallback(`adminTool/interactions/${userId}/${interactionType}`);
  }
  setFirebaseEntry(`adminTool/interactions/admins/${adminId}/${interactionType}`, null);
}

export function onAdminLastCheckedNotesStatus(userId, adminId, subpath, callback) {
  doOnValueChange(`adminTool/${subpath}/${userId}`, (key, status) => {
    let notesUpdatedSinceLastAdminCheck = false;
    let lastEditedNotesTime = 0;
    if (status) {
      lastEditedNotesTime = _.get(status, 'lastEditedNotesTime');
      let lastEditedNotesAdmin = _.get(status, 'lastEditedNotesAdmin');
      if (lastEditedNotesAdmin != adminId) {
        let adminLastCheckedNotesTime = _.get(status, `lastCheckedNotesTime.${adminId}`);
        if (lastEditedNotesTime > adminLastCheckedNotesTime) {
          notesUpdatedSinceLastAdminCheck = true;
        }
      }
    }
    callback(lastEditedNotesTime, notesUpdatedSinceLastAdminCheck)
  });
}

export function clearAdminLastCheckedNotesStatusCB(userId, subpath) {
  clearValueChangeCallback(`adminTool/${subpath}/${userId}`);
}

export function setAdminLastCheckedNotesTime(userId, adminId, subpath) {
  setFirebaseEntry(`adminTool/${subpath}/${userId}/lastCheckedNotesTime/${adminId}`, Date.now());
}

export function setLastEditedNotesStatus(userId, adminId, subpath) {
  setFirebaseEntry(`adminTool/${subpath}/${userId}/lastEditedNotesAdmin`, adminId);
  setFirebaseEntry(`adminTool/${subpath}/${userId}/lastEditedNotesTime`, Date.now());
}

// Note: Not putting this function in TodoUtil.js because of circular reference :(
export async function createTODOAsync(userId, desc, todoImportance, todoShorthand, typeName, timestamp /* opt */, inReplyTo) {
  let date;
  let hourMinuteString;
  let todosPath;

  if (timestamp) {
    let scheduledTime = new Date(timestamp)
    date = getLocalDateString(scheduledTime, DEFAULT_TIMEZONE).replace(/-/g, "/");
    let timeString = scheduledTime.toTimeString().split(' ')[0];
    let timeStringSplit = timeString.split(':');
    let hourString = timeStringSplit[0];
    let minString = '00';
    hourMinuteString = `${hourString}:${minString}`;
    todosPath = `todos-archive/${hourString}/${minString}`
  } else {
    date = getLocalDateString(new Date(), DEFAULT_TIMEZONE).replace(/-/g, "/");
    hourMinuteString = 'na:na';
    todosPath = 'todos';
  }

  //databaseHelper.setFirebaseEntry(`todos/${userId}/${typeName}/${Date()}`,
  let newEntry = {
    description: desc,
    recurrence: `${date}-None-${hourMinuteString}`,
    importance: todoImportance
  };

  if (!_.isEmpty(todoShorthand)) {
    newEntry.shorthand = todoShorthand;
  }

  if (!_.isEmpty(inReplyTo)) {
    newEntry.inReplyTo = inReplyTo;
  }

  pushFirebaseEntry(`${todosPath}/${userId}/${typeName}`, newEntry);
}

// Same for these and Util.js
const DEFAULT_TIMEZONE = -7;

function getLocalDateString(d, timezoneOffset) {
  d = new Date((d).getTime() + (timezoneOffset * 60 * 60 * 1000));
  return getUTCDateString(d);
}

function getUTCDateString(d) { // This should only be called for any anlready-offsetted dates
  let year = d.getUTCFullYear();
  let date = ("0" + d.getUTCDate()).slice(-2); // Append 0 to 1-digit numbers to force 2-digits
  let month = ("0" + (d.getUTCMonth() + 1)).slice(-2); // month is 0 base indexed
  return year + "-" + month + "-" + date;
}

const USER_PROGRESS_PATH = 'adminTool/userProgress';
export function setUserProgress(userId, type, val) {
  setFirebaseEntry(`${USER_PROGRESS_PATH}/${userId}/${type}`, val);
}

export function doOnUserProgressMod(callback) {
  doOnChildChanged(USER_PROGRESS_PATH, (key, val) => {
    callback(key, val);
  });
  doOnChildAdded(USER_PROGRESS_PATH, (key, val) => {
    callback(key, val);
  });
  doOnChildRemoved(USER_PROGRESS_PATH, (key, val) => {
    callback(key, val);
  });
}

export function clearUserProgressModCallback() {
  clearChildChangedCallback(USER_PROGRESS_PATH);
  clearChildAddedCallback(USER_PROGRESS_PATH);
  clearChildRemovedCallback(USER_PROGRESS_PATH);
}

const CRUISING_PATH = 'adminTool/cruising';
export function doOnCruisingUserChange(userId, callback) {
  doOnValueChange(`${CRUISING_PATH}/${userId}`, callback);
}

export function clearCruisingUserChangeCallback(userId) {
  clearValueChangeCallback(`${CRUISING_PATH}/${userId}`);
}

export function setCruisingUser(userId, val) {
  setFirebaseEntry(`${CRUISING_PATH}/${userId}`, val);
}

/***** Firestore accessors for v2 *****/
export function doOnUserStatusUpdate(callbackOnUpdate) {
  firestore.collection('userStatus').onSnapshot(subscriptionsSnap => {
    subscriptionsSnap.docChanges().forEach(change => {
      if (change.type === 'added') {
        callbackOnUpdate(change.doc.id, change.doc.data());
      }
    });
  });
}

// Single collection group listener over every userTodos/{userId}/dataEntry. Prefer this over initDataEntryTodosListeners
// per user: one listener per user (1000+) gets the client throttled by Firestore with resource-exhausted errors.
export function initAllDataEntryTodosListener(callbackOnUpdate, callbackOnDelete) {
  return firestore.collectionGroup('dataEntry').onSnapshot(todosSnap => {
    todosSnap.docChanges().forEach(change => {
      const userDocRef = change.doc.ref.parent.parent;
      if (!userDocRef || userDocRef.parent.id !== 'userTodos') {
        return; // Some other collection named 'dataEntry'.
      }
      const userId = userDocRef.id;

      if ((change.type === 'added' || change.type === 'modified') && callbackOnUpdate) {
        callbackOnUpdate(change.doc.data(), change.doc.id, userId);
      }

      if (change.type === 'removed') {
        deletePendingLog(userId, change.doc.id);

        if (callbackOnDelete) {
          callbackOnDelete(change.doc.id, userId);
        }
      }
    });
  }, err => {
    console.error(`initAllDataEntryTodosListener encountered error: ${err}`);
  });
}

export function initDataEntryTodosListeners(userId, callbackOnUpdate, callbackOnDelete) {
  firestore.collection('userTodos').doc(userId).collection('dataEntry').onSnapshot(todosSnap => {
    todosSnap.docChanges().forEach(change => {
      if ((change.type === 'added' || change.type === 'modified') && callbackOnUpdate) {
        callbackOnUpdate(change.doc.data(), change.doc.id, userId);
      }

      if (change.type === 'removed') {
        deletePendingLog(userId, change.doc.id);

        if (callbackOnDelete) {
          callbackOnDelete(change.doc.id, userId);
        }
      }
    });
  }, err => {
    console.error(`initDataEntryTodosListeners encountered error for ${userId}: ${err}`);
  });
}

export async function _addDataEntryTodoAsync(userId, logId, lastTodoContent, lastTodoId) {
  let lastTodoNumIdx = lastTodoId.lastIndexOf('_'); // Todo id's are formatted like <log id>_<#>
  let lastTodoNum = _.toNumber(lastTodoId.substr(lastTodoNumIdx + 1));
  firestore.collection('userTodos').doc(userId).collection('dataEntry').doc(`${logId}_${lastTodoNum + 1}`).set(lastTodoContent);
}

export async function getPendingLogForUserAsync(userId, docId) {
  let doc = await firestore.collection('userPendingLogs').doc(userId).collection('foods').doc(docId).get();
  return doc;
}

export async function getTodoForUserAsync(userId, docId) {
  let doc = await firestore.collection('userTodos').doc(userId).collection('dataEntry').doc(docId).get();
  return doc;
}

export async function updatePendingLogsForUserAsync(userId, newEntry) {
  await firestore.collection('userPendingLogs').doc(userId).set(
    newEntry,
    { merge: true }
  )
}

// Returns true if a pending log was found and we succesfully updated this data entry todo.
// Otherwise, set this data entry to Need Help and return false.
export async function updateDataEntryTodoAsync(userId, todoId, newFoodEntry, userName) {
  let pendingLog = await getPendingLogForUserAsync(userId, todoId);
  if (pendingLog.exists) {
    await firestore.collection('userTodos').doc(userId).collection('dataEntry').doc(todoId).set(newFoodEntry, { merge: true });
    return true;
  } else {
    console.error(`updateDataEntryTodoAsync error: Unexpected todo id ${todoId}`);

    fetch(process.env.REACT_APP_API_URL + '/pingSlackChannel', {
      method: 'POST',
      body: JSON.stringify({
        channelName: 'clientMsgAlertsData',
        message: `Warning: Found zombie todo while logging for user ${userId}:${userName} with todoId ${todoId}: ${newFoodEntry.name} (${newFoodEntry.consolidatedServingName}). Auto-marking it as Need Help to unblock DEP from submitting.` // Note: Don't include double quotes in the message, or else it won't make it to slack.
      }),
      headers: { "Content-Type": "application/json" }
    });

    fetch(process.env.REACT_APP_API_URL + '/pingSlackChannel', {
      method: 'POST',
      body: JSON.stringify({
        channelName: 'productAutomations',
        message: `Warning: Found zombie todo while logging for user ${userId}:${userName} with todoId ${todoId}: ${newFoodEntry.name} (${newFoodEntry.consolidatedServingName}). Auto-marking it as Need Help to unblock DEP from submitting.` // Note: Don't include double quotes in the message, or else it won't make it to slack.
      }),
      headers: { "Content-Type": "application/json" }
    });

    await firestore.collection('userTodos').doc(userId).collection('dataEntry').doc(todoId).set(
      {
        'needsHelp': true,
        'lastNeededHelp': Date.now()
      }, { merge: true }
    );

    return false;
  }
}

export async function deleteFood(userId, targetDate, docId) {
  await firestore.collection('userLogs').doc(userId).collection('dates').doc(targetDate)
    .collection('foods').doc(docId).delete();
  let data = {};
  data[targetDate] = true;
  firestore.collection('userReportRefreshRequests').doc(userId).set(
    data, { merge: true }
  );
}

export async function logAllFoodsAndReportsAsync(userId, entries, intention, skippedAnyFoods) {
  let containsAnyNewEntries = false; // i.e., not corrections
  let batch = firestore.batch();
  for (let entry of entries) {
    let food = entry.foodEntry;
    let docId = entry.docId;
    let logFoodRef = firestore.collection('userLogs').doc(userId).collection('dates').doc(food.targetDate)
      .collection('foods').doc(docId);
    batch.set(logFoodRef, food);

    let data = {};
    data[food.targetDate] = true;
    let reportRefreshRef = firestore.collection('userReportRefreshRequests').doc(userId);
    batch.set(reportRefreshRef, data, { merge: true });

    if (intention === SUBMIT_FOOD_INTENTION.AddOrCorrect && food.revisionHistory.length <= 2) {
      containsAnyNewEntries = true;
    } else if (intention === SUBMIT_FOOD_INTENTION.Move) {
      let dateParts = food.targetDate.split('-'); // YYYY-MM-DD
      let readableDate = `${dateParts[1]}/${dateParts[2]}`;
      queueNotification(batch, `${userId}_moved_${docId}_${food.targetDate}`, userId, `Moved to ${readableDate}: ${food.consolidatedServingName} ${food.name}.`, null);
    } else if (intention === SUBMIT_FOOD_INTENTION.Copy) {
      let dateParts = food.targetDate.split('-'); // YYYY-MM-DD
      let readableDate = `${dateParts[1]}/${dateParts[2]}`;
      queueNotification(batch, `${userId}_copied_${docId}_${food.targetDate}`, userId, `Copied to ${readableDate}: ${food.consolidatedServingName} ${food.name}.`, null);
    } else if (intention === SUBMIT_FOOD_INTENTION.Correct) {
      queueNotification(batch, `${userId}_corrected_${docId}`, userId, `Corrected: ${food.consolidatedServingName} ${food.name}.`, null);
    } else {
      // This is different than SUBMIT_FOOD_INTENTION.Correct, which gets set when Admin decides to update a food entry themselves.
      const correctionData = await isUserSubmittedCorrection(userId, docId);
      if (correctionData.isUserSubmittedCorrection) {
        queueNotification(batch, `${userId}_corrected_${docId}`, userId, `Corrected: ${food.consolidatedServingName} ${food.name}.`, null);
      }

      if (correctionData.foodEditAnalytics !== null && correctionData.foodEditAnalytics.updatedNotes && correctionData.lastAdminThatSubmitted !== null) {
        Analytics.logDEPCorrection(userId, correctionData.lastAdminThatSubmitted);
      }
    }

    if (intention === SUBMIT_FOOD_INTENTION.AddOrCorrect) {
      batch.delete(firestore.collection('userTodos').doc(userId).collection('dataEntry').doc(docId));
      batch.delete(firestore.collection('userPendingLogs').doc(userId).collection('foods').doc(docId));
    }
  }

  if (containsAnyNewEntries) {
    if (skippedAnyFoods) {
      queueNotification(batch, `${userId}_updatedEntry`, userId, 'Updated: Your pending food entries. The ones still pending are still being worked on.', 'updatedEntry');
    } else {
      queueNotification(batch, `${userId}_updatedEntry`, userId, 'Updated: All pending food entries.', 'updatedEntry');
    }
  }

  batch.delete(firestore.collection('userTodos').doc(userId));
  await batch.commit();
}

async function isUserSubmittedCorrection(userId, todoId) {
  const pendingLog = await getPendingLogForUserAsync(userId, todoId);
  const retVal = { isUserSubmittedCorrection: false, lastAdminThatSubmitted: null, foodEditAnalytics: {} };

  if (pendingLog.exists) {
    const pendingLogData = pendingLog.data();
    // Assume min length of 3: Once for user original log, once for DEP submission, once for user correction.
    if (pendingLogData.revisionHistory && pendingLogData.revisionHistory.length > 2) {
      const lastIndex = pendingLogData.revisionHistory.length - 1;
      const userCorrectedText = pendingLogData.revisionHistory[lastIndex];
      const depLoggedText = pendingLogData.revisionHistory[lastIndex - 1];

      if (userCorrectedText.startsWith('User corrected:')) {
        retVal.isUserSubmittedCorrection = true;
        if (pendingLogData.foodEditAnalytics != null) {
          retVal.foodEditAnalytics = pendingLogData.foodEditAnalytics;
        }

        if (depLoggedText.startsWith('You logged:')) {
          const depMatches = depLoggedText.match(/<did>(.*?)<\/did>/);
          if (!_.isEmpty(depMatches)) {
            const depMatch = depMatches[0];
            // Remove the <did> and </did> before returning.
            retVal.lastAdminThatSubmitted = depMatch.substring(5, depMatch.length - 6);
          }
        } // Else: This check fails if user is NOT updating something after DEP logged. In that case, assume they were just self-correcting (e.g., a typo)
      }
    }
  }
  return retVal;
}

// Rights to userLogs/<uid>/dates/<date>/recipeFood location which is picked up by dbsync in Cloud Functions
// which will index this in user-food-history with timesLogged = 0.
// We call it recipeFood because this recipe doesn't contain ingredient breakdown and so is treated like a generic food.
// vHIST-r2: May not need this after history-release2 is done and we support ingredients breakdown,
// where we don't need to pre-index recipes anymore for immediate lookup by DEP anymore.
export async function addRecipeFoodToIndex(userId, targetDate, recipeFood) {
  const res = await firestore.collection('userLogs').doc(userId).collection('dates').doc(targetDate)
    .collection('recipeFoods').add(recipeFood);
  return res.id;
}

export function doOnRecipeFoodIndexed(userId, date, recipeFoodId, callbackOnUpdate) {
  return firestore.collection('userLogs').doc(userId).collection('dates').doc(date)
    .collection('recipeFoods').doc(recipeFoodId).onSnapshot(docSnapshot => {
      callbackOnUpdate(!!docSnapshot.data().indexed);
    }, err => {
      console.log(`doOnRecipeFoodIndexed encountered error: ${err}`);
      callbackOnUpdate(false);
    });
}

function queueNotification(batch, docId, userId, body, tag) {
  let notifRef = firestore.collection('pendingNotifications').doc(docId);
  let notifContent = {
    userId: userId,
    title: 'Coach Viva',
    body: body
  };
  if (tag) {
    notifContent.tag = tag;
  }

  batch.set(notifRef, notifContent);
}

export function initLoggedFoodsListener(userId, targetDate, callbackOnUpdate, callbackOnDelete) {
  return firestore.collection('userLogs').doc(userId).collection('dates').doc(targetDate)
    .collection('foods').onSnapshot(snap => {
      snap.docChanges().forEach(change => {
        if ((change.type === 'added' || change.type === 'modified') && callbackOnUpdate) {
          callbackOnUpdate(change.doc.data(), change.doc.id);
        }

        if (change.type === 'removed' && callbackOnDelete) {
          if (callbackOnDelete) {
            callbackOnDelete(change.doc.id);
          }
        }
      });
    });
}

export function initFoodReportsListener(userId, targetDate, callbackOnUpdate, callbackOnDelete) {
  return firestore.collection('userLogs').doc(userId).collection('dates').doc(targetDate)
    .collection('foodReports').onSnapshot(snap => {
      snap.docChanges().forEach(change => {
        if ((change.type === 'added' || change.type === 'modified') && callbackOnUpdate) {
          callbackOnUpdate(change.doc.data(), change.doc.id);
        }

        if (change.type === 'removed' && callbackOnDelete) {
          if (callbackOnDelete) {
            callbackOnDelete(change.doc.id);
          }
        }
      });
    });
}

export async function getFoodReports(userId, targetDate) {
  var snap = await firestore.collection('userLogs').doc(userId).collection('dates').doc(targetDate)
    .collection('foodReports').get();

  var returnObj = {};
  if (!snap.empty) {
    (snap).forEach(doc => {
      returnObj[doc.id] = doc.data();
    });
  }

  return returnObj;
}

export async function deleteUserFoodTodo(userId, docId) {
  let doc = await getTodoForUserAsync(userId, docId);
  if (doc.exists) {
    doc.ref.delete();
  }
}

export async function deletePendingLog(userId, docId) {
  let doc = await getPendingLogForUserAsync(userId, docId);
  if (doc.exists) {
    doc.ref.delete();
  }
}

export async function getUserStatusAsync(userId) {
  let doc = await firestore.collection('userStatus').doc(userId).get();
  if (doc.exists) {
    return doc.data();
  } else {
    return {};
  }
}

export function initNotesListeners(userId, callbackOnUpdate) {
  return firestore.collection('userAdminNotes').doc(userId).collection('notes').onSnapshot(notesSnap => {
    notesSnap.docChanges().forEach(change => {
      callbackOnUpdate(change.doc.data(), change.doc.id);
    });
  });
}

export async function setUserNotes(userId, type, data) {
  await firestore.collection('userAdminNotes').doc(userId).collection('notes').doc(type).set(data);
}

export async function appendToUserNotes(userId, type, addedContent) {
  let doc = await firestore.collection('userAdminNotes').doc(userId).collection('notes').doc(type).get();
  let data = doc.exists ? doc.data() : { 'content': '' };
  data['content'] += `\n\n${addedContent}`;
  await setUserNotes(userId, type, data);
}

async function _getLastFoodTargetUpdatedDate(userId, targetDate) { // Get the date the target was last updated <= targetDate.
  let lastUpdatedSnap = await firestore.collection('userTargets').doc(userId).collection('histories')
    .where('date', '<=', targetDate)
    .orderBy('date', 'desc').limit(1).get();

  let lastUpdatedDate = lastUpdatedSnap.empty ? null : lastUpdatedSnap.docs[0].id;
  return lastUpdatedDate;
}

export async function initFoodTargetsListenerAsync(userId, targetDate, callbackOnUpdate, callbackOnDelete) {
  let lastUpdatedDate = await _getLastFoodTargetUpdatedDate(userId, targetDate);
  if (_.isEmpty(lastUpdatedDate)) {
    return null;
  }

  return firestore.collection('userTargets').doc(userId).collection('histories').doc(lastUpdatedDate)
    .collection('food').onSnapshot(async (snap) => {
      snap.docChanges().forEach(change => {
        if ((change.type === 'added' || change.type === 'modified') && callbackOnUpdate) {
          callbackOnUpdate(change.doc.data(), change.doc.id);
        }

        if (change.type === 'removed' && callbackOnDelete) {
          if (callbackOnDelete) {
            callbackOnDelete(change.doc.id);
          }
        }
      });
    });
}

export async function setFoodTargetAsync(
  userId,
  targetName,
  targetDate,
  data
) {
  let newUpdatedTargets = {};
  let lastUpdatedDate = await _getLastFoodTargetUpdatedDate(userId, targetDate);
  if (!_.isEmpty(lastUpdatedDate)) {
    let lastUpdatedSnap = await firestore.collection('userTargets').doc(userId).collection('histories').doc(lastUpdatedDate).collection('food').get();

    if (!lastUpdatedSnap.empty) {
      (lastUpdatedSnap).forEach(doc => {
        newUpdatedTargets[doc.id] = doc.data();
      });
    }
  }

  newUpdatedTargets[targetName] = data; // After this, newUpdatedTargets should contain all the existing targets + new one.

  let batch = firestore.batch();

  let ref1 = firestore.collection('userTargets').doc(userId).collection('histories').doc(targetDate);
  batch.set(ref1, { 'date': targetDate }, { merge: true });

  for (let targetName in newUpdatedTargets) {
    let ref2 = firestore.collection('userTargets').doc(userId).collection('histories').doc(targetDate)
      .collection('food').doc(targetName);
    batch.set(ref2, newUpdatedTargets[targetName], { merge: true });
  }

  await batch.commit();
}

export function requestReportRefresh(userId, targetDate) {
  let data = {};
  data[targetDate] = true;

  firestore.collection('userReportRefreshRequests').doc(userId).set(
    data,
    { merge: true }
  );
}

export function initRecipeCartListener(userId, callback, logId) {
  if (logId) {
    return firestore.collection('userAdminRecipes').doc(userId).collection('recipes').doc(logId).collection('ingredients').onSnapshot(snap => {
      let ingredients = {};
      snap.forEach((doc) => {
        let ingredient = doc.data();
        ingredients[doc.id] = ingredient;
      });
      callback(ingredients);
    });
  } else {
    return firestore.collection('userAdminRecipes').doc(userId).collection('recipes').doc('cart').collection('ingredients').onSnapshot(snap => {
      let ingredients = {};
      snap.forEach((doc) => {
        let ingredient = doc.data();
        ingredients[doc.id] = ingredient;
      });
      callback(ingredients);
    });
  }
}

export async function deleteIngredientFromRecipeCart(userId, ingredientId, logId) {
  if (logId) {
    await firestore.collection('userAdminRecipes').doc(userId).collection('recipes').doc(logId)
      .collection('ingredients').doc(ingredientId).delete();
  } else {
    await firestore.collection('userAdminRecipes').doc(userId).collection('recipes').doc('cart')
      .collection('ingredients').doc(ingredientId).delete();
  }
}

export async function deleteEverythingFromRecipeCart(userId, logId) {
  let snap;
  if (logId) {
    snap = await firestore.collection('userAdminRecipes').doc(userId).collection('recipes').doc(logId)
      .collection('ingredients').get();
  } else {
    snap = await firestore.collection('userAdminRecipes').doc(userId).collection('recipes').doc('cart')
      .collection('ingredients').get();
  }
  let docs = snap.docs;
  docs.forEach((doc) => {
    doc.ref.delete();
  });
}

export async function updateIngredientInRecipeCart(userId, foodFormEntry, ingredientId, logId) {
  if (logId) {
    await firestore.collection('userAdminRecipes').doc(userId).collection('recipes').doc(logId)
      .collection('ingredients').doc(ingredientId).set(foodFormEntry);
  } else {
    await firestore.collection('userAdminRecipes').doc(userId).collection('recipes').doc('cart')
      .collection('ingredients').doc(ingredientId).set(foodFormEntry);
  }
}

export async function rebuildRecipeCart(userId, logId, ingredients) {
  if (!logId) {
    return; // Not implemented.
  }

  if (ingredients && ingredients.length > 0) {
    let previousIngredientsSnap = await firestore.collection('userAdminRecipes').doc(userId).collection('recipes')
      .doc(logId).collection('ingredients').get();

    if (!previousIngredientsSnap.empty) {
      for (let doc of previousIngredientsSnap.docs) {
        await firestore.collection('userAdminRecipes').doc(userId).collection('recipes')
          .doc(logId).collection('ingredients').doc(doc.id).delete();
      }
    }

    for (let ingredient of ingredients) {
      ingredient.revisionHistory = [
        `${ingredient.name ? ingredient.name : ''} (${ingredient.servingDescription ? ingredient.servingDescription : '1'})`
      ];
      // if (ingredient.notes) {
      //   ingredient.revisionHistory.push(ingredient.notes);
      // }

      ingredient.consolidatedServingName = ingredient.servingDescription ? ingredient.servingDescription : ''; // For back compat.
      await firestore.collection('userAdminRecipes').doc(userId).collection('recipes')
        .doc(logId).collection('ingredients').add(ingredient);
    }
  } else {
    return; // No ingredients supplied, do nothing.
  }
}

// This function tries to look up the real user name in allowedEmails (where we keep our MN registrants) via email match.
// If founds, it adds this to userStatus.
export async function findAndAddUserNameToStatus(userStatus) {
  const mightyNetworkUserSnap = await firestore.collection('allowedEmails').where('email', '==', _.isEmpty(userStatus.email) ? '' : userStatus.email).get();
  if (mightyNetworkUserSnap.docs.length > 0) {
    var userName = mightyNetworkUserSnap.docs[0].data().name;
    if (userName) {
      //console.log(`Found match for user ${userStatus.uid}, ${userStatus.email} with name ${userName}`)
      await firestore.collection('userStatus').doc(userStatus.uid).set({
        name: userName
      }, { merge: true });

      //console.log(`Returning ${userName}`)
      return userName;
    }
  }

  //console.log(`Couldn't find a match for ${userStatus.uid}, ${userStatus.email}`)
  return userStatus.email;
}

// For tracking data entry turnaround time
export async function updateTurnaroundTimeAnalytics(name, timePassedForUser, timeSpentByAdmin, todoItems) {
  // todoItems[todoId].dataEntryContent
  const logs = [];
  for (const todoId in todoItems) {
    const dataEntryContent = todoItems[todoId].dataEntryContent;
    if (!dataEntryContent) { // !dataEntryContent can be true for older todos from chatBot days.
      continue;
    }

    const logContent = {
      'description': dataEntryContent.revisionHistory[dataEntryContent.revisionHistory.length - 1],
      'updateHistory': dataEntryContent.loggedTimestamps,
      'markedAsNeedsHelp': dataEntryContent.lastNeededHelp != null && dataEntryContent.lastNeededHelp != undefined
    };
    logs.push(logContent);
  }
  const numLogs = Object.keys(todoItems).length;

  const now = Date.now().toString();
  await firestore.collection('dataEntryTurnaroundAnalytics').doc(now).set({
    name,
    timePassedForUser,
    timeSpentByAdmin,
    numLogs,
    logs,
    id: now
  }, { merge: true });
}

export function setTimeSpentOnUserTodo(userId, totalTimeSpent) {
  firestore.collection('userTodos').doc(userId).set({
    timeSpent: totalTimeSpent
  }, { merge: true });
}

export async function getTimeSpentOnUserTodo(userId) {
  const dataEntryColl = await firestore.collection('userTodos').doc(userId).collection('dataEntry').get();

  if (dataEntryColl.empty) {
    return null; // If there's no collection at all for this item, then this user no longer has any todos
  }

  const doc = await firestore.collection('userTodos').doc(userId).get();
  if (!doc.exists) { // Doc may not "exist" even if it has collections. That's ok.
    return 0;
  }

  return (doc.data().timeSpent === null || doc.data().timeSpent === undefined) ? 0 : doc.data().timeSpent;
}

/***** End Firestore *****/


// WEBPACK FOOTER //
// ./src/helpers/Database.js